import { RegistrationPreviousRequest, RegistrationProcessRequest } from "@shared/dtos/requests/registrationRequests.dto"
import { RegistrationResponse } from "@shared/dtos/responses/registrationResponses.dto"

import { axiosPublic } from "./generic/AxiosInterceptor/AxiosInterceptor"
import { makeFileInstance } from "./generic/FileInstance"

/**
 *  Process a part of a registration process. The endpoint will be called multiple times during
 *  a registration process.
 */
export const process = async (request: RegistrationProcessRequest): Promise<RegistrationResponse> => {
  const resp = await axiosPublic({
    url: "/public/registration/process",
    method: "post",
    data: request,
  })
  return resp.data
}

/**
 * Navigate to the previous step in the registration process.
 * Pops the last step from history and returns it with its formData.
 */
export const previous = async (request: RegistrationPreviousRequest): Promise<RegistrationResponse> => {
  const resp = await axiosPublic({
    url: "/public/registration/previous",
    method: "post",
    data: request,
  })
  return resp.data
}

/**
 * Fetch a preview of the previous GP letter PDF with placeholder data.
 * Requires encrypted registration data for authorization.
 *
 * @param previousGpRequestApproval - Whether the patient approves medical file transfer (reflected in preview)
 */
export const previewPreviousGpLetter = async (pageId: string, data: string, previousGpRequestApproval: boolean) => {
  const result = await axiosPublic({
    url: `/public/registration/preview/previousgpletter/${pageId}`,
    method: "get",
    params: { data, previousGpRequestApproval },
    responseType: "blob",
  })
  return makeFileInstance(result)
}
